/**
 * ポテンシャル分析設定APIクライアント（FKV3-13111）
 * バックエンドの /{accountCode}/potential-analysis-settings を呼び出す
 */

import { apiGet, apiPut } from './client';
import type {
  PotentialAnalysisSetting,
  UpdatePotentialAnalysisSettingRequest,
} from '@/lib/types/feature/potential-analysis-setting';

/**
 * ポテンシャル分析設定を取得する。
 *
 * 商品グループタイプはマスタの一覧に設定を重ねて返るため、未設定のタイプも
 * `enabled = false` で含まれる。
 */
export async function getPotentialAnalysisSetting(
  accountCode: string,
  authHeaders?: Record<string, string>,
): Promise<PotentialAnalysisSetting> {
  return apiGet<PotentialAnalysisSetting>(
    `/${accountCode}/potential-analysis-settings`,
    authHeaders,
  );
}

/**
 * ポテンシャル分析設定を保存する（差分ではなく全置換）。
 * 保存後の状態がそのまま返るため、呼び出し側で再取得する必要はない。
 */
export async function updatePotentialAnalysisSetting(
  accountCode: string,
  request: UpdatePotentialAnalysisSettingRequest,
  authHeaders?: Record<string, string>,
): Promise<PotentialAnalysisSetting> {
  return apiPut<PotentialAnalysisSetting>(
    `/${accountCode}/potential-analysis-settings`,
    request,
    authHeaders,
  );
}
